import { api } from '../api/client';
import { Category } from '../types';

export const getAllCategories = async (): Promise<Category[]> => {
  return api.get<Category[]>('/categories');
};

export const getNextCategoryCode = async (): Promise<string> => {
  const res = await api.get<{ categoryCode: string }>('/categories/next-code');
  return res.categoryCode;
};

export const createCategory = async (name: string): Promise<Category> => {
  return api.post<Category>('/categories', { name });
};

export const updateCategory = async (categoryCode: string, name: string): Promise<void> => {
  await api.patch(`/categories/${encodeURIComponent(categoryCode)}`, { name });
};

export const deleteCategory = async (categoryCode: string): Promise<void> => {
  await api.delete(`/categories/${encodeURIComponent(categoryCode)}`);
};
